import { Modal } from "antd";
import NetworkMessage from "@/components/NetworkMessage";
import Icon from "@ant-design/icons";
import { ReactComponent as NoWifi } from "@/assets/icons/NoWifi.svg";
import useNetwork from "@/stores/network";

const OfflineModal = () => {
  const { online } = useNetwork();

  return (
    <Modal
      open={!online}
      closable={false}
      maskClosable={false}
      footer={null}
      title={
        <NetworkMessage type="default">
          <Icon component={NoWifi} />
          <span>Currently offline</span>
        </NetworkMessage>
      }
      className="antd-custom-warning-modal"
    >
      <p>Please check your network connection before proceeding.</p>
    </Modal>
  );
};

export default OfflineModal;
